module.exports = __webpack_public_path__ + "img/snoskredforsvaret.d3054ea8.jpg";